import React, { useState } from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from "@chakra-ui/react";
import { BuilderListProps } from "../../FormBuilderTypes";
import { DragIcon } from "../../../icons/DragIcon";
import { nanoid } from "nanoid";
import { SearchIcon } from "../../../icons/SearchIcon";

const BuildersList = ({ list, handleDragStart, kyc, minimumTab }: BuilderListProps) => {
  const [search, setSearch] = useState("");

  const filterList = (search: string) => {
    const newList = kyc
      ? list.filter((res) => res.title !== "Bank Info" && res.title !== "Card")
      : list;
    return newList.filter((item) =>
      item.title.toLowerCase().includes(search.toLowerCase())
    );
  };

  return (
    <Box display={"flex"} flexDirection={"column"} mt={"1"}>
      {!minimumTab && <Flex w={72} mb={"2"} width={"100%"}>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <SearchIcon w={5} h={5} />
          </InputLeftElement>

          <Input
            pl={10}
            name="name"
            type="search"
            placeholder="Search"
            bg={"white"}
            width={"100%"}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
      </Flex>}
      {filterList(search).map((item) => (
        <Box
          display={"flex"}
          alignItems={"center"}
          p={"4"}
          mb={"1"}
          height={"100%"}
          width={"100%"}
          bg={"white"}
          borderRadius={"md"}
          border={"2px"}
          borderStyle={"solid"}
          borderColor={"whitesmoke"}
          key={nanoid()}
          draggable
          cursor={"grab"}
          onDragStart={(e) => handleDragStart(e, item)}
        >
          <DragIcon />
          <Box
            borderRadius={"5"}
            bg={"whitesmoke"}
            color={"blue.900"}
            h={"9"}
            w={"9"}
            ms="3"
            me="1"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          ></Box>{" "}
          <Box>
            <Text fontSize={"xs"} mb="0" fontWeight={"semibold"}>
              {item?.title}
            </Text>
            <Text fontSize={"xs"} mb={"0"} color={"gray"}>
              {item?.body}
            </Text>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default BuildersList;
